module.exports = __webpack_public_path__ + "static/media/Karate Master.6d62cfaa.jpg";